import { getPeriscopeMetadataRouteUri } from '@sonar-software/sonar-ts-lib';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { useApiResource } from '../useApiResource';
import { useMemo } from 'react';

export interface UsePeriscopeMetadataResult<T> {
	loading: boolean;
	metadata?: T;
}

export function usePeriscopeMetadata<T>(
	sonarObjectId: number,
	sonarObjectType: SonarObjectType
): UsePeriscopeMetadataResult<T> {
	const targetUri = useMemo(
		() => getPeriscopeMetadataRouteUri(sonarObjectType, sonarObjectId),
		[ sonarObjectId, sonarObjectType ]
	);

	const { loading, resource } = useApiResource<T>(targetUri);

	return {
		loading,
		metadata: resource
	};
}
